import { v4 as uuid } from 'uuid';

import {
  CheckboxesDataField,
  DataField,
  ReviewStageDataFieldTypeEnum,
} from 'components/FormBuilder/schemas';

import {
  createDefaultCommonField,
  CreateDefaultCommonFieldArgs,
} from '../CommonQuestions/helpers';

export const createNewCheckboxOption =
  (): CheckboxesDataField['options'][number] => ({
    _id: uuid(),
    label: '',
    value: '',
    visible: true,
  });

export const createDefaultCheckboxesField = (
  args: CreateDefaultCommonFieldArgs,
): CheckboxesDataField => ({
  type: ReviewStageDataFieldTypeEnum.checkboxes,
  ...createDefaultCommonField(args),
  options: [createNewCheckboxOption()],
});

export function isCheckboxesDataField(
  dataField: DataField,
): dataField is CheckboxesDataField {
  return dataField.type === ReviewStageDataFieldTypeEnum.checkboxes;
}
